import { c as _c } from "react/compiler-runtime";
// TODO: validation? sanitize?

import { convertLexicalToHTML } from '@payloadcms/richtext-lexical/html';
import type { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
function processHtmlLinks(html: string): string {
  return html.replace(/<a\s+(?![^>]*target=)([^>]*?)href=["']([^"']+)["']([^>]*)>/gi, '<a $1href="$2" target="_blank" rel="noopener noreferrer" class="text-uzh-blue underline hover:text-uzh-blue/80 transition-colors"$3>');
}
function processImages(html: string): string {
  // Handle markdown-style images that weren't converted: ![alt](url)
  let processed = html.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '<img src="$2" alt="$1" class="max-w-full h-auto rounded-lg my-4" />');

  // Add styling to existing img tags
  processed = processed.replace(/<img([^>]*)>/gi, (match, attrs) => {
    // Don't add classes if they already exist
    if (attrs.includes('class=')) {
      return match;
    }
    return `<img${attrs} class="max-w-full h-auto rounded-lg my-4" />`;
  });
  return processed;
}
export default function RichTextHTML(t0) {
  const $ = _c(4);
  const {
    data
  } = t0;
  let t1;
  if ($[0] !== data) {
    const html = convertLexicalToHTML({
      data
    });
    t1 = processHtmlLinks(processImages(html));
    $[0] = data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const processedHtml = t1;
  let t2;
  if ($[2] !== processedHtml) {
    t2 = <div className="prose prose-sm md:prose-base max-w-none prose-headings:mb-2 prose-headings:mt-4 prose-p:my-2 prose-ol:my-2 prose-ul:my-2 prose-li:my-1 [&>:first-child]:mt-0 [&>:last-child]:mb-0" dangerouslySetInnerHTML={{
      __html: processedHtml
    }} />;
    $[2] = processedHtml;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}